import React from 'react';
import {
  Badge,
  Copy,
  Flex,
  Square,
  Stack,
} from '@grubhubprod/gh-cookbook-react';

export interface BasePaymentMethodDisplayProps {
  icon: React.ReactNode;
  primaryText: string;
  secondaryText?: string;
  isDefault: boolean;
  showBorder?: boolean;
}

export function BasePaymentMethodDisplay({
  icon,
  primaryText,
  secondaryText,
  isDefault,
  showBorder = true,
}: BasePaymentMethodDisplayProps): JSX.Element {
  const content = (
    <Flex justifyContent="space-between" alignItems="center">
      <Stack>
        <Flex alignItems="center">
          <Stack x="x-sm">{icon}</Stack>
          <Flex flexDirection="column">
            <Copy variant="body">{primaryText}</Copy>
            {secondaryText && (
              <Copy variant="caption" color="secondaryText">
                {secondaryText}
              </Copy>
            )}
          </Flex>
        </Flex>
      </Stack>
      <Stack>
        {isDefault && (
          <Badge flavor="muted" size="sm" radius="squared">
            Default
          </Badge>
        )}
      </Stack>
    </Flex>
  );

  if (!showBorder) {
    return content;
  }

  return (
    <Square
      inset="x-sm"
      border="1px solid"
      borderColor="mediumLine"
      borderRadius="8px"
      maxWidth="375px"
    >
      {content}
    </Square>
  );
}
